import bookingApiService from '@/services/bookingApiService';
import bookingSectionService from '@/services/bookingSectionService';
import offerService from '@/services/offerService';
import vehicleService from '@/services/vehicleService';
import SMP_CONFIG from '@/util/smp_config';
import { each, find } from 'lodash';
import locationApiService from '@/modules/simpleService/services/locationApiService';

const getServices = function ({ commit }, payload) {
  let externalIds = [
    ...payload.services.map((service) => service.externalId),
    ...payload.additionalServices.map((service) => service.externalId)
  ];
  let params = vehicleService.decodeFicode(payload.eCode);
  params.offset = 0;
  params.max = 1000;
  params.externalIds = externalIds;
  return bookingApiService.getServices(params).then(res => {
    getServiceWithPrices(filterSelectedServices(payload.services, res.data)).then(res => {
      commit('SET_SERVICES', res);
    });
    // get all additional
    getServiceWithPrices(filterSelectedServices(payload.additionalServices, res.data)).then(res => {
      commit('SET_ADDITIONAL_SERVICES', res);
    });
  });
};

const filterSelectedServices = (services, data) => {
  let updatedServices = [];
  each(services, (service) => {
    let selectedService = find(data, { externalId: service.externalId });
    updatedServices.push(selectedService);
  });

  return updatedServices;
};

const getServiceWithPrices = (services) => {
  return locationApiService.getServicePrices(services.map(service => { return { externalId: service.externalId } }), SMP_CONFIG.contextConfig.locationId).then(res => {
    services.forEach((service) => {
      service.price = null;
      let tmp = find(res.data, priced => priced.serviceId === service.id);
      if (tmp) {
        service.price = tmp.price;
        service.priceGross = tmp.priceGross;
      }
    });

    return services;
  });
};

const getBookingDetails = ({ commit }, key) => {
  return bookingApiService.getBookingDetails(key)
    .then((res) => {
      let sections = res.latest.bookedOfferDetail.actualSections;
      bookingSectionService.flattenServices(sections.sections);
      res.bookingServices = bookingSectionService.breakdown(sections);
      commit('SET_BOOKING', res);
      return res;
    });
};

const getLatestBookingVersion = ({ commit, state }, payload) => {
  return bookingApiService.getLatestBookingVersion(payload.key, { selectedServiceIds: payload.selectedServiceIds })
    .then((res) => {
      let sections = res.latest.bookedOfferDetail.actualSections;
      bookingSectionService.flattenServices(sections.sections);
      res.bookingServices = bookingSectionService.breakdown(sections);
      commit('SET_LATEST_VERSION', res);
      return res;
    });
};

const updateOffer = ({ commit }, payload) => {
  return offerService.getOfferDetails(payload.key, { selectedServiceIds: payload.selectedServiceIds })
    .then((res) => {
      const sections = res.data.actualSections;
      bookingSectionService.flattenServices(sections.sections);
      res.data.bookingServices = bookingSectionService.breakdown(sections);
      res.data.additionalServiceSections = sections.sections.filter(section => section.serviceType === 'ADDITIONAL');
      commit('SET_OFFER', res.data);
    });
};

const getOfferList = ({ commit, state, rootState }) => {
  return offerService.createOfferSearch(state, rootState)
    .then((res) => {
      const offerSearch = res.data;
      return offerService.getOfferList(offerSearch.id);
    })
    .then((res) => {
      commit('SET_OFFERS', res.data);
      return res;
    });
};

const getOfferListByOfferSearchId = ({ commit, state }, offerSearchId) => {
  return offerService.getOfferList(offerSearchId)
    .then((res) => {
      commit('SET_OFFERS', res.data);
      return res;
    });
};

const getOfferDetails = ({ commit }, offerkey) => {
  return offerService.getOfferDetails(offerkey).then(res => {
    const sections = res.data.actualSections;
    if (sections) {
      bookingSectionService.flattenServices(sections.sections);
      res.data.bookingServices = bookingSectionService.breakdown(sections);
      res.data.additionalServiceSections = sections.sections.filter(section => section.serviceType === 'ADDITIONAL');
    }
    commit('SET_OFFER', res.data);
    return res;
  });
};

const getOfferSearch = ({ commit }, offerkey) => {
  return offerService.getOfferSearch(offerkey).then(res => {
    commit('SET_OFFER_SEARCH', res.data);
    return res;
  });
};

const getPartQualityTypeList = ({ commit }) => {
  return offerService.getPartQualityTypeList()
    .then(res => {
      commit('SET_PART_QUALITY_TYPE_LIST', res.data);
      return res;
    })
};

const getGuildList = ({ commit }) => {
  return offerService.getGuildList()
    .then(res => {
      commit('SET_GUILD_LIST', res.data);
      return res;
    })
};

const createBooking = ({ commit }, booking) => {
  return bookingApiService.createBooking(booking);
};

const createSimpleServiceBooking = function ({ commit }, payload) {
  let searchConfig = {
    locationIds: [SMP_CONFIG.contextConfig.locationId],
    serviceIds: payload.serviceIds
  };
  return offerService.createSimpleOfferSearch(searchConfig)
    .then(res => offerService.getOfferList(res.data.id))
    .then((res) => {
      if (res.data.length) {
        let offerKey = res.data[0].offerKey;
        let booking = {
          offerKey: offerKey,
          status: 'BOOKED',
          salutation: payload.form.salutation,
          emailAddress: payload.form.email,
          givenname: payload.form.givenname,
          surname: payload.form.surname,
          phone: payload.form.telNumber,
          dmsCustomerId: payload.form.customer,
          storagePlace: payload.form.storage,
          selectedServiceIds: payload.serviceIds,
          licenseNumber: payload.form.plateNumber,
          timeslotId: payload.form.selectedTimeSlot.id
        };
        if (payload.comment) booking.comment = payload.comment;
        return bookingApiService.createBooking(booking);
      }
    })
    .then(res => {
      // temporary fix: salutation is not present in the booking object received from backend at the moment => have to add it here
      res.data.salutation = payload.form.salutation;
      commit('SET_BOOKING', res.data);

      return res;
    });
};

export default {
  getLatestBookingVersion,
  getBookingDetails,
  getOfferList,
  getOfferListByOfferSearchId,
  getPartQualityTypeList,
  getGuildList,
  getOfferDetails,
  getOfferSearch,
  updateOffer,
  createBooking,
  getServices,
  createSimpleServiceBooking
};
